import script from "./Person.vue?vue&type=script&lang=ts&setup=true"
export * from "./Person.vue?vue&type=script&lang=ts&setup=true"

import "./Person.vue?vue&type=style&index=0&id=8fd54482&lang=postcss&scoped=true"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd54482"]])

export default __exports__